import { createContext } from 'react';

// Brand scheme set in the Brand panel; cascades to every block's theme so a
// brand change restyles the whole page (per-block Style overrides still win).
// This is the shape PERSISTED to the 'brand' craft doc.
export type Brand = { logoSrc?: string; primary?: string; accent?: string; text?: string; background?: string };

// A design token surfaced from wp_design_tokens (the classic store the AI brand
// generator + Design Tokens tab write to). Carried in context (NOT persisted in
// the brand doc) so block color pickers can offer the org's real tokens.
export type BrandToken = { id?: string; name: string; value: string; group?: string };

// Context value = the persisted brand scheme PLUS the live design tokens.
export type BrandContextValue = Brand & { tokens?: BrandToken[] };
export const BrandCtx = createContext<BrandContextValue>({});
